var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaviWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 5H12.4998C11.1738 5 9.90199 5.52678 8.9643 6.46447C8.02662 7.40215 7.49984 8.67392 7.49984 10C7.49984 11.3261 8.02662 12.5979 8.9643 13.5355C9.90199 14.4732 11.1738 15 12.4998 15H18.3332V16.6667C18.3332 16.8877 18.2454 17.0996 18.0891 17.2559C17.9328 17.4122 17.7208 17.5 17.4998 17.5H2.49984C2.27882 17.5 2.06686 17.4122 1.91058 17.2559C1.7543 17.0996 1.6665 16.8877 1.6665 16.6667V3.33333C1.6665 3.11232 1.7543 2.90036 1.91058 2.74408C2.06686 2.5878 2.27882 2.5 2.49984 2.5H17.4998C17.7208 2.5 17.9328 2.5878 18.0891 2.74408C18.2454 2.90036 18.3332 3.11232 18.3332 3.33333V5ZM12.4998 6.66667H19.1665V13.3333H12.4998C11.6158 13.3333 10.7679 12.9821 10.1428 12.357C9.51769 11.7319 9.1665 10.8841 9.1665 10C9.1665 9.11594 9.51769 8.2681 10.1428 7.64298C10.7679 7.01786 11.6158 6.66667 12.4998 6.66667ZM12.4998 9.16667V10.8333H14.9998V9.16667H12.4998Z",
    fill: "url(#paint0_linear_5021_46679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5021_46679",
    x1: 1.6665,
    y1: 10,
    x2: 19.3628,
    y2: 9.99929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviWallet);
export default __webpack_public_path__ + "static/media/naviWallet.34abb629e40721ea8b1db91d9aad283d.svg";
export { ForwardRef as ReactComponent };